import { Modal, Paper, Typography } from '@mui/material';
import { ValidationsErrorDialogStyles } from './styles';
import { useBulkUploadPoiActions } from '../actions';
import { IdmsErrorTable } from '@/components/Analysis/Idms/IdmsErrorTable';
import { csvStringToJson } from '@/components/Analysis/Idms/utils';

export const ValidationsErrorDialog = () => {
  const { getGetBulkModalState, closeAllModals, getErrors, getUploadInput } =
    useBulkUploadPoiActions();

  const state = getGetBulkModalState();
  const isOpen = state === 'validation';

  if (!isOpen) return <></>;

  const onClose = () => {
    closeAllModals();
  };

  const input = getUploadInput();
  const errors = getErrors();

  const { header, rows } = csvStringToJson(input?.csv as string);

  return (
    <Modal open={isOpen} onClose={onClose}>
      <Paper sx={ValidationsErrorDialogStyles}>
        <Typography fontWeight={'bold'} fontSize={20} my={2}>
          The file contains errors
        </Typography>
        <Typography>
          Note: This file cannot be uploaded due to exceptions highlighted in the table below. Hover
          over each highlighted value to view the specific exception.
        </Typography>
        <IdmsErrorTable errors={errors?.issue.error || []} header={header} rows={rows} />
      </Paper>
    </Modal>
  );
};
